import { UnapprovedDataColumns } from '../DataColumns/UnapprovedDataColumns';
import GridFlag from '../../../../Core/Components/GridFlag/GridFlag';
import {
  GridDateCell,
  BooleanFlagFilterCell,
} from '../../../../Core/Components/Filter/FilterElements';
import { MultiViewCalenderFilterCell } from 'smart-react';

/**
 * Grid columns list for Unapproved Organizations (requests).
 */
export const UnapprovedGridColumnsList = async ({
  dateRangefilter,
  setDateRangeFilter,
}) => {
  return UnapprovedDataColumns({
    MultiViewCalenderFilterCell,
    dateRangeFilter: dateRangefilter,
    setDateRangeFilter,
    GridDateCell,
    GridFlag,
    BooleanFlagFilterCell,
  });
};

export default UnapprovedGridColumnsList;